import { render, staticRenderFns } from "./DigitalClinics.vue?vue&type=template&id=49edf4c5&scoped=true"
import script from "./DigitalClinics.vue?vue&type=script&lang=js"
export * from "./DigitalClinics.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinics.vue?vue&type=style&index=0&id=49edf4c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edf4c5",
  null
  
)

export default component.exports